import { ReportsRoutePath } from "#src/routes/reports";
import { RoutePath } from "#src/utils/route";

export const CustomReportsListRoutePath = ReportsRoutePath.concat(
  new RoutePath<string, "tab">({
    title: "Custom Reports",
    path: "/custom-reports",
  })
);

export const CustomReportsListRouteTabs = {
  RecordsTab: "records",
  EmissionsTab: "emissions",
} as const;
